import { render, staticRenderFns } from "./vipshop.vue?vue&type=template&id=7579a820&scoped=true&"
import script from "./vipshop.vue?vue&type=script&lang=js&"
export * from "./vipshop.vue?vue&type=script&lang=js&"
import style0 from "./vipshop.vue?vue&type=style&index=0&id=7579a820&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7579a820",
  null
  
)

export default component.exports